'use strict';
/* Karmagick v1.0.4 — la pagina della luna (templates/page.luna.json): tutto ciò che non è il motore delle
   stelle (assets/kg-luna.js). Date e fasi dal cielo vero (assets/kg-cielo.js), scritte da Intl nella
   lingua della pagina e nel fuso del visitatore.
   - cielo: i giorni da scorrere sotto la luna di stelle; scegliendo un giorno la luna prende la sua fase
     e le stelle riscrivono il nome;
   - calendario: il mese con la luna di ogni sera, il giorno scelto, le fasi principali, il file .ics;
   - fasi: la fase di stanotte e la data della prossima volta per ognuna delle otto;
   - segno: il segno di adesso, fino a quando, i prossimi passaggi;
   - ruota: i nomi attorno alla ruota e le otto feste dell'anno;
   - piene: le lune piene dei prossimi dodici mesi coi loro nomi;
   - quaderno: l'intenzione del ciclo, salvata solo in questo browser.
   Tutto si aggiorna da solo (2026-10-29): kg-luna.js batte ogni 30 s e tornando sulla scheda (evento kg-luna:ora)
   e ogni parte si rifà quando serve, senza togliere il giorno o il mese che chi legge ha scelto. */
(() => {
  if (window.KG_LUNA_PAGINA) return;
  window.KG_LUNA_PAGINA = true;
  const C = window.KG_CIELO;
  if (!C) return;
  const fermo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sciogli = document.createElement('textarea');
  const chiaro = (v) => {
    if (typeof v === 'string') { sciogli.innerHTML = v; return sciogli.value; }
    if (Array.isArray(v)) return v.map(chiaro);
    if (v && typeof v === 'object') for (const k of Object.keys(v)) v[k] = chiaro(v[k]);
    return v;
  };
  const leggi = (el, sel) => { try { return chiaro(JSON.parse(el.querySelector(sel)?.textContent || '{}')); } catch (e) { return {}; } };
  /* i testi comuni (fasi, feste, segni, leve) stanno nella prima sezione che li porta */
  const comuni = leggi(document, '[data-kg-luna-testi]');
  const lingua = comuni.lingua === 'en' ? 'en-GB' : comuni.lingua || document.documentElement.lang || undefined;
  const fmt = (o) => { try { return new Intl.DateTimeFormat(lingua, o); } catch (e) { return new Intl.DateTimeFormat(undefined, o); } };
  const F = {
    breve: fmt({ weekday: 'short', day: 'numeric', month: 'short' }),
    breveOra: fmt({ weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }),
    lungo: fmt({ weekday: 'long', day: 'numeric', month: 'long' }),
    lungoAnno: fmt({ weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }),
    data: fmt({ day: 'numeric', month: 'long' }),
    dataAnno: fmt({ day: 'numeric', month: 'long', year: 'numeric' }),
    ora: fmt({ hour: '2-digit', minute: '2-digit' }),
    mese: fmt({ month: 'long', year: 'numeric' }),
    meseBreve: fmt({ month: 'short' }),
    sett: fmt({ weekday: 'short' }),
    settStretta: fmt({ weekday: 'narrow' }),
    num: fmt({ day: 'numeric' }),
  };
  const percento = (() => { try { return new Intl.NumberFormat(lingua, { style: 'percent', maximumFractionDigits: 0 }); } catch (e) { return { format: (x) => `${Math.round(x * 100)}%` }; } })();
  const maiuscola = (s) => (s ? s.charAt(0).toLocaleUpperCase(lingua) + s.slice(1) : s);
  const terminatore = window.KG_LUNA?.terminatore;
  const SVG = 'http://www.w3.org/2000/svg';
  /* una piccola luna in SVG per una data */
  function lunetta(l, classe = '') {
    const s = document.createElementNS(SVG, 'svg');
    s.setAttribute('viewBox', '0 0 100 100');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', `kg-lunetta ${classe}`);
    const c = document.createElementNS(SVG, 'circle');
    c.setAttribute('cx', '50'); c.setAttribute('cy', '50'); c.setAttribute('r', '46'); c.setAttribute('class', 'kg-luna__svg-buio');
    const p = document.createElementNS(SVG, 'path');
    p.setAttribute('class', 'kg-luna__svg-luce');
    if (terminatore) p.setAttribute('d', terminatore(l.elong / 360, 46));
    s.append(c, p);
    return s;
  }
  const sera = (d) => { const x = new Date(d); x.setHours(21, 0, 0, 0); return x; };
  const chiaveGiorno = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const stessoGiorno = (a, b) => chiaveGiorno(a) === chiaveGiorno(b);
  const piu = (d, giorni) => { const x = new Date(d); x.setDate(x.getDate() + giorni); return x; };
  const datiDi = (l, s) => [(comuni.luce || '§').replace('§', percento.format(l.luce)), (comuni.nelSegno || '§').replace('§', comuni.segni?.[s.segno] || '')].join(' · ');
  const metti = (el, testo) => { if (el) el.textContent = testo || ''; };
  const leva = (a, voce) => {
    if (!a) return;
    if (!voce?.url || !voce?.title) { a.hidden = true; return; }
    a.href = voce.url; a.hidden = false;
    (a.querySelector('[data-kg-leva-testo]') || a).textContent = voce.title;
  };
  let adesso = new Date();
  /* il tempo che passa: a ogni battito di kg-luna.js «adesso» va avanti e ogni parte decide se rifarsi */
  const alBattito = [];
  document.addEventListener('kg-luna:ora', (e) => {
    adesso = e.detail?.ora || new Date();
    for (const f of alBattito) { try { f(!!e.detail?.nuovoGiorno); } catch (err) { console.error('[kg-luna-pagina]', err); } }
  });
  /* la luna di un giorno: adesso se è oggi, altrimenti la sera di quel giorno */
  const lunaDel = (giorno) => C.luna(stessoGiorno(giorno, adesso) ? adesso : sera(giorno));

  /* ── il cielo: i giorni da scorrere ── */
  function cielo(radice) {
    const api = radice.kgLuna;
    const giorni = radice.querySelector('[data-kg-giorni]');
    const torna = radice.querySelector('[data-kg-torna]');
    if (!api || !giorni) return;
    /* le prossime lune restano quelle di adesso, qualunque giorno si guardi */
    const prossime = () => {
      const l0 = C.luna(adesso);
      radice.querySelectorAll('[data-kg-campo="nuova"]').forEach((el) => metti(el, l0.nuova && F.breveOra.format(l0.nuova)));
      radice.querySelectorAll('[data-kg-campo="piena"]').forEach((el) => metti(el, l0.piena && F.breveOra.format(l0.piena)));
    };
    prossime();
    const quandoDi = (g) => (stessoGiorno(g, adesso) ? comuni.stanotte || '' : maiuscola(F.lungo.format(g)));
    radice.querySelectorAll('[data-kg-campo="quando"]').forEach((el) => metti(el, quandoDi(adesso)));
    const DA = -10, A = 50;
    let voci = [];
    /* la striscia dei giorni attorno a oggi: si rifà a mezzanotte */
    function striscia() {
      giorni.replaceChildren();
      voci = [];
      for (let i = DA; i <= A; i++) {
        const g = piu(adesso, i);
        const l = lunaDel(g);
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'kg-giorno';
        b.setAttribute('role', 'option');
        b.dataset.giorno = chiaveGiorno(g);
        b.setAttribute('aria-label', `${maiuscola(F.lungo.format(g))}, ${comuni.fasi?.[l.chiave]?.name || ''}`);
        if (g.getDate() === 1 || i === DA) { const m = document.createElement('span'); m.className = 'kg-giorno__mese'; m.textContent = F.meseBreve.format(g); b.append(m); }
        const w = document.createElement('span'); w.className = 'kg-giorno__sett'; w.textContent = F.sett.format(g);
        const n = document.createElement('span'); n.className = 'kg-giorno__num'; n.textContent = F.num.format(g);
        b.append(w, lunetta(l, l.esatta ? 'kg-lunetta--esatta' : ''), n);
        if (i === 0) b.classList.add('kg-giorno--oggi');
        giorni.append(b);
        const j = voci.length;
        b.addEventListener('click', () => scegli(j));
        voci.push({ b, g });
      }
    }
    let scelto = -1, attesa = 0;
    function scegli(j, { scorri = true, liscio = true } = {}) {
      j = Math.max(0, Math.min(voci.length - 1, j));
      if (j === scelto) return;
      if (scelto >= 0) { voci[scelto].b.classList.remove('kg-giorno--scelto'); voci[scelto].b.setAttribute('aria-selected', 'false'); }
      scelto = j;
      const { b, g } = voci[j];
      b.classList.add('kg-giorno--scelto'); b.setAttribute('aria-selected', 'true');
      if (scorri) b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: liscio && !fermo ? 'smooth' : 'auto' });
      const oggi = stessoGiorno(g, adesso);
      if (torna) torna.hidden = oggi;
      const l = api.mostra(oggi ? adesso : sera(g), { quando: quandoDi(g) });
      api.motore.cielo(l);
      /* le stelle riscrivono il nome quando il dito si ferma */
      clearTimeout(attesa);
      attesa = setTimeout(() => { api.motore.riscrivi(); api.motore.ridisegna(); }, 160);
    }
    /* il giorno al centro della striscia è quello scelto */
    let rif = 0;
    giorni.addEventListener('scroll', () => {
      cancelAnimationFrame(rif);
      rif = requestAnimationFrame(() => {
        const q = giorni.getBoundingClientRect(), mezzo = q.left + q.width / 2;
        let best = 0, d = Infinity;
        voci.forEach(({ b }, j) => { const r = b.getBoundingClientRect(); const x = Math.abs(r.left + r.width / 2 - mezzo); if (x < d) { d = x; best = j; } });
        scegli(best, { scorri: false });
      });
    }, { passive: true });
    giorni.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); scegli(scelto + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    torna?.addEventListener('click', () => scegli(-DA));
    /* all'inizio oggi è al centro, senza muovere la pagina */
    const centra = (j = -DA) => { const b = voci[j].b; giorni.scrollLeft = b.offsetLeft - (giorni.clientWidth - b.offsetWidth) / 2; };
    striscia();
    centra();
    voci[-DA].b.classList.add('kg-giorno--scelto'); voci[-DA].b.setAttribute('aria-selected', 'true');
    scelto = -DA;
    new ResizeObserver(() => { if (scelto === -DA) centra(); }).observe(giorni);
    /* col tempo: le prossime lune; se si guarda stanotte, la luna di adesso; a mezzanotte la striscia si rifà
       attorno al giorno nuovo e resta sul giorno che si guardava (stanotte, se era stanotte) */
    alBattito.push((nuovoGiorno) => {
      prossime();
      const eraOggi = scelto === -DA;
      if (nuovoGiorno) {
        const visto = voci[scelto] && chiaveGiorno(voci[scelto].g);
        striscia();
        let j = eraOggi ? -DA : voci.findIndex((v) => chiaveGiorno(v.g) === visto);
        if (j < 0) j = -DA;
        scelto = -1;
        scegli(j, { scorri: false });
        centra(j);
        return;
      }
      if (!eraOggi) return;
      const l = api.mostra(adesso, { quando: comuni.stanotte || '' });
      api.motore.cielo(l);
      api.motore.ridisegna();
    });
  }

  /* ── il calendario del mese ── */
  function calendario(sez) {
    const extra = leggi(sez, '[data-kg-luna-extra]');
    const meseEl = sez.querySelector('[data-kg-cal-mese]');
    const griglia = sez.querySelector('[data-kg-cal-griglia]');
    const sett = sez.querySelector('[data-kg-cal-settimana]');
    const elenco = sez.querySelector('[data-kg-cal-fasi]');
    const c = (n) => sez.querySelector(`[data-kg-c="${n}"]`);
    /* l'intestazione della settimana, da lunedì: il 5 gennaio 2026 è un lunedì */
    for (let i = 0; i < 7; i++) { const s = document.createElement('span'); s.textContent = F.settStretta.format(new Date(2026, 0, 5 + i)); s.title = F.sett.format(new Date(2026, 0, 5 + i)); sett.append(s); }
    let mese = new Date(adesso.getFullYear(), adesso.getMonth(), 1);
    let scelto = new Date(adesso), oggiVisto = new Date(adesso);
    function dettaglio(g) {
      const l = lunaDel(g), s = C.segnoLuna(stessoGiorno(g, adesso) ? adesso : sera(g));
      const f = comuni.fasi?.[l.chiave] || {};
      metti(c('quando'), stessoGiorno(g, adesso) ? `${extra.oggi || ''} · ${maiuscola(F.lungo.format(g))}` : maiuscola(F.lungo.format(g)));
      metti(c('nome'), f.name + (l.esatta ? ` · ${F.ora.format(l.esatta.quando)}` : ''));
      metti(c('dati'), datiDi(l, s));
      metti(c('frase'), f.line);
      leva(c('leva'), comuni.leve?.[l.chiave]);
    }
    function disegna() {
      meseEl.textContent = maiuscola(F.mese.format(mese));
      griglia.replaceChildren();
      elenco.replaceChildren();
      const primo = new Date(mese), vuoti = (primo.getDay() + 6) % 7;
      for (let i = 0; i < vuoti; i++) griglia.append(Object.assign(document.createElement('span'), { className: 'kg-cal__vuoto' }));
      const fine = new Date(mese.getFullYear(), mese.getMonth() + 1, 0).getDate();
      for (let d = 1; d <= fine; d++) {
        const g = new Date(mese.getFullYear(), mese.getMonth(), d);
        const l = lunaDel(g);
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'kg-cal__giorno';
        if (stessoGiorno(g, adesso)) b.classList.add('kg-cal__giorno--oggi');
        if (stessoGiorno(g, scelto)) b.classList.add('kg-cal__giorno--scelto');
        b.setAttribute('aria-pressed', String(stessoGiorno(g, scelto)));
        b.setAttribute('aria-label', `${maiuscola(F.lungo.format(g))}, ${comuni.fasi?.[l.chiave]?.name || ''}`);
        const n = document.createElement('span'); n.className = 'kg-cal__num'; n.textContent = d;
        b.append(n, lunetta(l, l.esatta ? 'kg-lunetta--esatta' : ''));
        if (l.esatta) {
          const o = document.createElement('span'); o.className = 'kg-cal__ora'; o.textContent = F.ora.format(l.esatta.quando);
          b.append(o);
          const li = document.createElement('li');
          li.className = `kg-cal__fase kg-cal__fase--${l.esatta.tipo}`;
          const nome = document.createElement('span'); nome.className = 'kg-cal__fase-nome'; nome.textContent = comuni.fasi?.[l.esatta.tipo]?.name || '';
          const quando = document.createElement('span'); quando.className = 'kg-cal__fase-quando'; quando.textContent = `${maiuscola(F.lungo.format(l.esatta.quando))}, ${F.ora.format(l.esatta.quando)}`;
          li.append(lunetta(l), nome, quando);
          elenco.append(li);
        }
        b.addEventListener('click', () => {
          scelto = g;
          griglia.querySelectorAll('.kg-cal__giorno--scelto').forEach((x) => { x.classList.remove('kg-cal__giorno--scelto'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('kg-cal__giorno--scelto'); b.setAttribute('aria-pressed', 'true');
          dettaglio(g);
        });
        griglia.append(b);
      }
      if (scelto.getMonth() !== mese.getMonth() || scelto.getFullYear() !== mese.getFullYear()) {
        /* in un altro mese si legge il primo giorno con una fase principale */
        const primaFase = C.fasiTra(new Date(mese), new Date(mese.getFullYear(), mese.getMonth() + 1, 1))[0];
        dettaglio(primaFase ? primaFase.quando : new Date(mese));
      } else dettaglio(scelto);
    }
    sez.querySelectorAll('[data-kg-mese]').forEach((b) => b.addEventListener('click', () => {
      mese = new Date(mese.getFullYear(), mese.getMonth() + Number(b.dataset.kgMese), 1);
      disegna();
    }));
    disegna();
    /* col tempo: se si guardava oggi nel suo mese, a mezzanotte si passa al giorno nuovo (anche al mese nuovo);
       altrimenti si sposta solo il segno di oggi. Durante il giorno si rinfresca la luce di oggi */
    alBattito.push((nuovoGiorno) => {
      const eraOggi = stessoGiorno(scelto, oggiVisto) && mese.getMonth() === oggiVisto.getMonth() && mese.getFullYear() === oggiVisto.getFullYear();
      if (nuovoGiorno) {
        if (eraOggi) { scelto = new Date(adesso); mese = new Date(adesso.getFullYear(), adesso.getMonth(), 1); }
        oggiVisto = new Date(adesso);
        disegna();
      } else if (eraOggi) dettaglio(scelto);
    });

    /* il file di calendario: lune nuove e piene e le otto feste dei prossimi dodici mesi */
    sez.querySelector('[data-kg-ics]')?.addEventListener('click', () => {
      const fine = piu(adesso, 366);
      const piene = new Map(C.lunePiene(adesso, fine).map((p) => [p.quando.getTime(), p]));
      const utc = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      const giorno = (d) => chiaveGiorno(d).replace(/-/g, '');
      const testo = (s) => String(s || '').replace(/[\\;,]/g, (m) => `\\${m}`).replace(/\n/g, '\\n');
      const righe = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Karmagick//Moon//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', `X-WR-CALNAME:${testo('Karmagick')}`];
      const ora = utc(new Date());
      for (const f of C.fasiTra(adesso, fine).filter((x) => x.tipo === 'new' || x.tipo === 'full')) {
        const p = piene.get(f.quando.getTime());
        const nome = comuni.fasi?.[f.tipo]?.name || '';
        const titolo = p && extra.piene?.[p.nome] ? `${nome} · ${extra.piene[p.nome]}` : nome;
        righe.push('BEGIN:VEVENT', `UID:${f.tipo}-${utc(f.quando)}@karmagick.com`, `DTSTAMP:${ora}`, `DTSTART:${utc(f.quando)}`, `DTEND:${utc(new Date(f.quando.getTime() + 36e5))}`,
          `SUMMARY:${testo(`${f.tipo === 'new' ? '●' : '○'} ${titolo}`)}`, `DESCRIPTION:${testo(comuni.fasi?.[f.tipo]?.line)}`, 'TRANSP:TRANSPARENT', 'END:VEVENT');
      }
      for (const anno of [adesso.getFullYear(), adesso.getFullYear() + 1]) {
        for (const f of C.feste(anno)) {
          if (f.quando < C.inizioGiorno(adesso) || f.quando > fine) continue;
          const x = comuni.feste?.[f.chiave] || {};
          const ev = ['BEGIN:VEVENT', `UID:${f.chiave}-${anno}@karmagick.com`, `DTSTAMP:${ora}`];
          if (f.esatta) ev.push(`DTSTART:${utc(f.quando)}`, `DTEND:${utc(new Date(f.quando.getTime() + 36e5))}`);
          else ev.push(`DTSTART;VALUE=DATE:${giorno(f.quando)}`, `DTEND;VALUE=DATE:${giorno(piu(f.quando, 1))}`);
          ev.push(`SUMMARY:${testo(`✦ ${x.name || f.chiave}`)}`, `DESCRIPTION:${testo(x.line)}`, 'TRANSP:TRANSPARENT', 'END:VEVENT');
          righe.push(...ev);
        }
      }
      righe.push('END:VCALENDAR');
      const blob = new Blob([righe.join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `${extra.file || 'karmagick-moons'}.ics`;
      document.body.append(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    });
  }

  /* ── le otto fasi: stanotte e la prossima volta ── */
  function fasi(sez) {
    scriviFasi(sez);
    alBattito.push((nuovoGiorno) => { if (nuovoGiorno) scriviFasi(sez); });
  }
  function scriviFasi(sez) {
    const extra = leggi(sez, '[data-kg-luna-extra]');
    sez.querySelectorAll('[data-kg-frazione]').forEach((p) => { if (terminatore) p.setAttribute('d', terminatore(Number(p.dataset.kgFrazione), 46)); });
    const oggi = C.luna(adesso);
    /* la prima volta, da domani, in cui ogni fase dà il nome alla sera */
    const prossime = {};
    for (let i = 1; i <= 32 && Object.keys(prossime).length < 8; i++) {
      const g = piu(adesso, i), l = C.luna(sera(g));
      if (!prossime[l.chiave]) prossime[l.chiave] = l.esatta ? F.breveOra.format(l.esatta.quando) : F.breve.format(g);
    }
    sez.querySelectorAll('[data-kg-fase]').forEach((li) => {
      const k = li.dataset.kgFase;
      const ora = k === oggi.chiave;
      li.classList.toggle('kg-fase--stanotte', ora);
      const s = li.querySelector('[data-kg-stanotte]');
      if (s) s.hidden = !ora;
      if (prossime[k]) metti(li.querySelector('[data-kg-prossima]'), (extra.prossima || '§').replace('§', prossime[k]));
    });
  }

  /* ── la luna nei segni ── */
  function segno(sez) {
    let visto = scriviSegno(sez, C.segnoLuna(adesso));
    /* la luna cambia segno ogni due giorni e mezzo, a qualunque ora */
    alBattito.push(() => {
      const ora = C.segnoLuna(adesso);
      if (ora.segno !== visto) visto = scriviSegno(sez, ora);
    });
  }
  function scriviSegno(sez, ora) {
    const extra = leggi(sez, '[data-kg-luna-extra]');
    const s = (n) => sez.querySelector(`[data-kg-s="${n}"]`);
    const x = extra.segni?.[ora.segno] || {};
    metti(s('nome'), (extra.nelSegno || '§').replace('§', x.name || ''));
    metti(s('fino'), (extra.fino || '§').replace('§', F.breveOra.format(ora.uscita)));
    metti(s('frase'), x.line);
    leva(s('leva'), x);
    const lista = s('passaggi');
    lista.replaceChildren();
    let t = new Date(ora.uscita.getTime() + 60e3);
    for (let i = 0; i < 6; i++) {
      const p = C.segnoLuna(t);
      const li = document.createElement('li');
      const n = document.createElement('span'); n.className = 'kg-segno__passaggio-nome'; n.textContent = extra.segni?.[p.segno]?.name || '';
      const q = document.createElement('span'); q.className = 'kg-segno__passaggio-quando'; q.textContent = F.breveOra.format(p.entrata);
      li.append(n, q);
      lista.append(li);
      t = new Date(p.uscita.getTime() + 60e3);
    }
    sez.querySelectorAll('[data-kg-segno]').forEach((li) => li.classList.toggle('kg-segni__voce--ora', li.dataset.kgSegno === ora.segno));
    sez.querySelector('[data-kg-segno-ora]').hidden = false;
    return ora.segno;
  }

  /* ── la ruota dell'anno: i nomi attorno, le ore di luce al centro e le altre sette feste. Si rifà da sola a
     mezzanotte, così la pagina resta giusta anche aperta per giorni ── */
  function ruota(radice) {
    scriviRuota(radice, adesso);
    alBattito.push((nuovoGiorno) => { if (nuovoGiorno) scriviRuota(radice, adesso); });
    radice.kgLuna?.motore.riscrivi();
  }
  function scriviRuota(radice, adesso) {
    const lista = radice.querySelector('[data-kg-feste]');
    const nomi = radice.querySelector('[data-kg-ruota-nomi]');
    const prossima = C.prossimaFesta(adesso);
    if (!prossima) return;
    lista?.replaceChildren();
    nomi?.replaceChildren();
    /* le ore di luce di oggi a 45° nord, contate a mezzogiorno come nelle tavole di alba e tramonto: il numero
       non cambia durante il giorno */
    const centro = radice.querySelector('[data-kg-ruota-luce]');
    if (centro) {
      const oggi = C.oreDiLuce(new Date(adesso.getFullYear(), adesso.getMonth(), adesso.getDate(), 12));
      const ieri = C.oreDiLuce(new Date(adesso.getFullYear(), adesso.getMonth(), adesso.getDate() - 1, 12));
      const minuti = Math.round(oggi * 60), diff = Math.round((oggi - ieri) * 60);
      const t = centro.dataset;
      centro.querySelector('[data-kg-campo="luce-oggi"]').textContent = (t.ore || '§h h §m′').replace('§h', Math.floor(minuti / 60)).replace('§m', String(minuti % 60).padStart(2, '0'));
      centro.querySelector('[data-kg-campo="luce-ieri"]').textContent = diff === 0 ? t.uguale || '' : ((diff < 0 ? t.meno : t.piu) || '').replace('§', Math.abs(diff));
    }
    /* le sette feste dopo la prossima (la prossima sta già accanto alla ruota), fino a un anno */
    const tutte = [...C.feste(adesso.getFullYear()), ...C.feste(adesso.getFullYear() + 1)].filter((f) => C.inizioGiorno(f.quando) >= C.inizioGiorno(adesso)).slice(1, 8);
    const quando = (f) => (f.esatta ? `${maiuscola(F.lungoAnno.format(f.quando))}, ${F.ora.format(f.quando)}` : maiuscola(F.lungoAnno.format(f.quando)));
    tutte.forEach((f, i) => {
      const x = comuni.feste?.[f.chiave] || {};
      const li = document.createElement('li');
      li.className = 'kg-festa';
      const h = document.createElement('h3'); h.className = 'kg-festa__nome'; h.textContent = x.name || '';
      const q = document.createElement('p'); q.className = 'kg-luna__dati'; q.textContent = quando(f);
      const p = document.createElement('p'); p.className = 'kg-festa__frase'; p.textContent = x.line || '';
      li.append(h, q, p);
      if (x.url && x.title) {
        const a = document.createElement('a'); a.className = 'kg-luna__leva'; a.href = x.url;
        a.innerHTML = '<span></span> <span class="kg-luna__freccia" aria-hidden="true">→</span>';
        a.firstChild.textContent = x.title;
        li.append(a);
      }
      lista?.append(li);
    });
    /* i nomi attorno alla ruota, dove stanno i loro nodi (0 in alto, in senso orario), appena fuori dal bordo
       dell'anello in quel punto: il bordo di fuori segue le ore di luce come nello shader (raggio 0,9 del
       posto, dal 48% al pieno a Litha) */
    if (nomi) {
      for (const f of C.feste(prossima.quando.getFullYear())) {
        const u = C.annoSullaRuota(f.esatta ? f.quando : new Date(f.quando.getTime() + 12 * 36e5));
        const s = Math.sin(u * Math.PI * 2), c = Math.cos(u * Math.PI * 2);
        const fuori = 0.9 * (0.48 + (0.52 * C.oreDiLuceSullaRuota(u)) / 15.62) * 50;
        const li = document.createElement('li');
        li.textContent = comuni.feste?.[f.chiave]?.name || '';
        li.style.setProperty('--x', `calc(50% + ${s.toFixed(4)} * (${fuori.toFixed(2)}% + 0.6rem))`);
        li.style.setProperty('--y', `calc(50% - ${c.toFixed(4)} * (${fuori.toFixed(2)}% + 0.6rem))`);
        li.style.setProperty('--ax', (-50 + s * 50).toFixed(1) + '%');
        li.style.setProperty('--ay', (-50 - c * 50).toFixed(1) + '%');
        if (f.chiave === prossima.chiave) li.className = 'kg-ruota__nome--prossima';
        nomi.append(li);
      }
    }
  }

  /* ── le lune piene dei prossimi dodici mesi ── */
  function piene(sez) {
    let prima = scriviPiene(sez);
    /* passata la piena in cima, l'elenco ricomincia dalla successiva */
    alBattito.push((nuovoGiorno) => { if (nuovoGiorno || (prima && adesso > prima)) prima = scriviPiene(sez); });
  }
  function scriviPiene(sez) {
    const extra = leggi(sez, '[data-kg-luna-extra]');
    const lista = sez.querySelector('[data-kg-piene]');
    lista.replaceChildren();
    const tutte = C.lunePiene(adesso, piu(adesso, 372)).slice(0, 13);
    tutte.forEach((p, i) => {
      const li = document.createElement('li');
      li.className = `kg-piena${i === 0 ? ' kg-piena--prossima' : ''}`;
      const l = C.luna(p.quando);
      const n = document.createElement('p'); n.className = 'kg-piena__nome'; n.textContent = extra.piene?.[p.nome] || '';
      const q = document.createElement('p'); q.className = 'kg-luna__dati'; q.textContent = `${maiuscola(F.lungoAnno.format(p.quando))}, ${F.ora.format(p.quando)}`;
      li.append(lunetta(l, 'kg-lunetta--piena'), n, q);
      if (p.blu) { const b = document.createElement('p'); b.className = 'kg-piena__blu'; b.textContent = extra.blu || ''; li.append(b); }
      lista.append(li);
    });
    return tutte[0]?.quando || null;
  }

  /* ── il quaderno: un'intenzione per ciclo, solo in questo browser ── */
  function quaderno(sez) {
    const extra = leggi(sez, '[data-kg-luna-extra]');
    const foglio = sez.querySelector('[data-kg-quaderno]');
    const q = (n) => sez.querySelector(`[data-kg-q="${n}"]`);
    const area = foglio?.querySelector('textarea');
    if (!foglio || !area) return;
    const CHIAVE = 'kg-luna-quaderno';
    const carica = () => { try { return JSON.parse(localStorage.getItem(CHIAVE) || '{}') || {}; } catch (e) { return {}; } };
    const salva = (o) => { try { localStorage.setItem(CHIAVE, JSON.stringify(o)); return true; } catch (e) { return false; } };
    const cicloDi = () => C.luna(adesso).ultimaNuova || adesso;
    let ciclo = cicloDi();
    let id = chiaveGiorno(ciclo);
    metti(q('ciclo'), (extra.ciclo || '§').replace('§', F.dataAnno.format(ciclo)));
    let note = carica();
    area.value = note[id]?.testo || '';
    /* alla luna nuova comincia un ciclo nuovo: il foglio si apre su quello (mai mentre si sta scrivendo) e
       l'intenzione del ciclo prima passa fra le passate */
    alBattito.push(() => {
      const c = cicloDi(), nuovo = chiaveGiorno(c);
      if (nuovo === id || document.activeElement === area) return;
      ciclo = c; id = nuovo;
      note = carica();
      metti(q('ciclo'), (extra.ciclo || '§').replace('§', F.dataAnno.format(ciclo)));
      area.value = note[id]?.testo || '';
      metti(q('stato'), '');
      passati();
    });
    function passati() {
      const lista = q('lista');
      lista.replaceChildren();
      const chiavi = Object.keys(note).filter((k) => k !== id && note[k]?.testo).sort().reverse();
      q('passati').hidden = !chiavi.length;
      for (const k of chiavi) {
        const li = document.createElement('li');
        const d = document.createElement('p'); d.className = 'kg-luna__dati'; d.textContent = (extra.ciclo || '§').replace('§', F.dataAnno.format(new Date(`${k}T12:00:00`)));
        const t = document.createElement('p'); t.className = 'kg-quaderno__nota'; t.textContent = note[k].testo;
        const x = document.createElement('button'); x.type = 'button'; x.className = 'kg-quaderno__cancella'; x.textContent = extra.cancella || '×';
        x.addEventListener('click', () => { delete note[k]; salva(note); passati(); });
        li.append(d, t, x);
        lista.append(li);
      }
    }
    foglio.addEventListener('submit', (e) => {
      e.preventDefault();
      note = carica();
      const testo = area.value.trim();
      if (testo) note[id] = { testo, quando: new Date().toISOString() }; else delete note[id];
      metti(q('stato'), salva(note) ? extra.salvata : '');
    });
    area.addEventListener('input', () => metti(q('stato'), ''));
    foglio.hidden = false;
    passati();
  }

  /* le parti della pagina; il cielo aspetta che il motore abbia scritto i suoi testi */
  const avvia = () => {
    document.querySelectorAll('[data-kg-luna="pagina"]').forEach(cielo);
    document.querySelectorAll('[data-kg-luna="ruota"]').forEach(ruota);
    const parti = { calendario, fasi, segno, piene, quaderno };
    document.querySelectorAll('[data-kg-luna-parte]').forEach((sez) => { try { parti[sez.dataset.kgLunaParte]?.(sez); } catch (e) { console.error('[kg-luna-pagina]', e); } });
  };
  if (document.querySelector('[data-kg-luna]') && !document.querySelector('[data-kg-luna]').kgLuna) document.addEventListener('kg-luna:pronta', function una() { document.removeEventListener('kg-luna:pronta', una); avvia(); });
  else avvia();
})();
